// One editor must keep its own answer and revision even when both parties
// answered a question. A response from the other party remains the fallback.
export function selectChecklistAnswers(answers = [], drafts = [], answeredBy) {
  const result = {};
  const stamp = answer => Date.parse(answer.answered_at || '') || 0;
  for (const answer of [...answers, ...drafts.map(row => ({ ...row, answered_by: answeredBy }))]) {
    const key = answer.frontend_key || (answer.extra_question_id ? `extra-${answer.extra_question_id}` : `q-${answer.question_id}`);
    const previous = result[key];
    const own = answer.answered_by === answeredBy;
    const previousOwn = previous?.answered_by === answeredBy;
    if (!previous || (own && !previousOwn) || (own === previousOwn && stamp(answer) >= stamp(previous))) result[key] = answer;
  }
  return result;
}
